import React, {useEffect, useState} from "react";

// UI
import MaterialTable from "@material-table/core";
import _ from "lodash";

// Table Params
import {OPTIONS, LOCALIZATION, getColumns} from "./Params/UsersKpiDetail";
import {tableIcons} from "../../ui-components/TableIcons";
import TableStyle from "../TableStyle";
import {ConnectionsWorksiteModal} from "../Modals/ConnectionsWorksiteModal";
import ConnectionsSurveyModal from "../Modals/ConnectionsSurveyModal";
import useCountryAxiosInstance from "../../hooks/useCountryAxiosInstance";


function UsersKpiDetailTable({detail, intl, countryCode, sales, isManager}) {

  const countryApiRequest = useCountryAxiosInstance();

  const [roles, setRoles] = useState();
  const [status, setStatus] = useState();
  const [showWorksites, setShowWorksites] = useState();
  const [showSurveys, setShowSurveys] = useState();
  const [worksiteTypes, setWorksiteTypes] = useState();

  useEffect(() => {
    const fetchWorksiteTypes = async () => {
      try {
        const [allWorksiteTypes] = await Promise.all([
          countryApiRequest.get(`/worksite_types/all`),
        ]);
        setWorksiteTypes(allWorksiteTypes);
      } catch (error) {
        console.log("errore", error);
      }
    };

    fetchWorksiteTypes();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {

    setRoles([...new Set(detail.map((i) => i.role))]
      .sort().reduce((obj, i) => _.set(obj, [i], intl.formatMessage({id: i})), {}))

    setStatus([...new Set(detail.map((i) => i.status))]
      .sort().reduce((obj, i) => _.set(obj, [i], intl.formatMessage({id: 'user_status_' + i})), {}))


  }, [detail, intl])



  const lookups = {roles: roles, status: status, sales: sales}
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    setColumns(getColumns(intl, isManager, lookups, setShowWorksites, setShowSurveys));
  }, [roles, sales, status, isManager]);

  return (
    <>
      <TableStyle>
        <MaterialTable
          columns={columns}
          data={detail}
          icons={tableIcons}
          isLoading={!lookups}
          options={OPTIONS}
          localization={LOCALIZATION}
          pagination
        />
      </TableStyle>
      {worksiteTypes && showWorksites && ConnectionsWorksiteModal(showWorksites, setShowWorksites, worksiteTypes, countryCode, intl)}
      {worksiteTypes && showSurveys && ConnectionsSurveyModal({
        intl,
        surveys: showSurveys,
        countryCode,
        worksiteTypes,
        onExit: () => { setShowSurveys(undefined); },
      })}

    </>
  );
}

export default React.memo(UsersKpiDetailTable, (props, nextProps) => {
  // Render component only when users changes
  return _.isEqual(props.detail, nextProps.detail) && _.isEqual(props.sales, nextProps.sales);
});
